import { html } from 'lit';

export default function (message) {
  return html`
    <div class="alert alert-danger mb-4">
      <i class="bi bi-exclamation-circle-fill me-1"></i>
      ${message}
    </div>
  `;
}
